<p class="welcome">
  <span
    *ngIf="!continueMode.active; else continue"
    [innerHTML]="'pushbox/welcome-message' | translate: { emoji: welcomeEmoji }"></span>

  <ng-template #continue>
    <span [innerHTML]="'pushbox/continue-message' | translate: { emoji: continueEmoji }"></span>
  </ng-template>
</p>

<div class="actions">
  <button mat-raised-button type="button" color="primary" (click)="acquireAndProcessNextTask()">
    <mat-icon class="channel-icon">play_circle_outline</mat-icon>
    <span translate="pushbox/process-new-message"></span>
  </button>

  <div>
    <p
      *ngIf="continueMode.active"
      class="continue"
      [translate]="'pushbox/processed-chrono'"
      [translateParams]="{ min: continueMode.minutes }"></p>
  </div>

  <!-- button disabled after counters are loaded and not during loading, to be able to click the button if the counters take some time to load (no error if click) -->
  <button
    mat-raised-button
    type="button"
    class="ongoing"
    (click)="goToOngoingByMe()"
    [disabled]="taskListConfiguration.counter !== undefined && counters.length && !taskListConfiguration.counter[0]">
    <span translate="pushbox/ongoing"></span>
    <ng-container *ngIf="taskListConfiguration.counter !== undefined && counters.length; else loading">
      <span
        class="counter"
        [ngClass]="{ zero: !taskListConfiguration.counter[0] }"
        [innerHTML]="taskListConfiguration.counter[0] | truncateCounter"></span>
    </ng-container>
    <ng-template #loading><span class="counter">...</span></ng-template>
  </button>

  <button mat-raised-button type="button" class="logout" (click)="logout()">
    <span translate="logout/logout"></span>
  </button>
</div>
